module.exports = __webpack_public_path__ + "resources/globe/crudeoil.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=resources/globe/crudeoil.json!./src/resources/globe/crudeoil.json
// module id = 2505
// module chunks = 0